const CONTACT_EMAIL = "hello@evograding.com";

export default function Contact() {
  return (
    <div className="min-h-screen bg-[#faf9fb] text-[#07001a]">
      <header className="mx-auto flex w-full max-w-[960px] items-center justify-between px-6 py-5">
        <a
          className="font-['Figtree',sans-serif] text-[20px] font-black text-[#07001a] no-underline"
          href="/"
        >
          evo
        </a>
        <nav className="flex items-center gap-4">
          <a
            className="font-['Figtree',sans-serif] text-[14px] font-semibold text-[#776f7b] no-underline hover:text-[#07001a]"
            href="/support"
          >
            Support
          </a>
          <a
            className="font-['Figtree',sans-serif] text-[14px] font-semibold text-[#776f7b] no-underline hover:text-[#07001a]"
            href="/privacy"
          >
            Privacy
          </a>
          <a
            className="font-['Figtree',sans-serif] text-[14px] font-semibold text-[#776f7b] no-underline hover:text-[#07001a]"
            href="/terms"
          >
            Terms
          </a>
        </nav>
      </header>

      <main className="mx-auto w-full max-w-[840px] px-6 pb-16 pt-8">
        <article className="terms-content">
          <h1>Contact Us</h1>

          <p>
            Have a question, some feedback, or need a hand with Evo? We'd love to
            hear from you. Reach out any time and we'll get back to you as soon
            as we can.
          </p>

          <h2>Email</h2>
          <p>
            The best way to reach us is by email at{" "}
            <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>. When writing
            in about an account or grading issue, please include the email
            address associated with your account so we can help you faster.
          </p>

          <h2>Looking for help?</h2>
          <p>
            For common questions about your account, subscription, grading, and
            more, visit our <a href="/support">Support page</a>.
          </p>
        </article>
      </main>
    </div>
  );
}
